<mat-form-field class="container-full-width" appearance="outline">
  <mat-label>Escolha a data</mat-label>
  <input matInput [min]="minDate" [matDatepicker]="picker" required="" />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
